export default "__VITE_ASSET__c1c16491__"